<template>
  <div class="container mx-auto px-20">
    <slot />
  </div>
</template>
